import React, {FC, useState} from 'react';

import {KeyboardActionsEnum} from '../../../libs/shared/core/src/helpers/browser/keyboardHelpers';
import {OpenConversationDialog} from '../../../libs/shared/ui/src/components/dialogs/openConversationDialog';
import {KeyboardShortcuts} from '../../../libs/shared/ui/src/components/keyboard/keyboardShortcuts';
import {
  getLinkErrorMessage,
  useLinkNavigation,
} from '../../../libs/shared/ui/src/components/navigation/useLinkNavigation';

/*
 * Component.
 */

export const OpenConversation: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const {navigateToLink, linkError, resetLinkError} = useLinkNavigation();

  const keyHandlers = {
    [KeyboardActionsEnum.GO_TO_CONVERSATION]: () => setIsOpen(true),
  };

  const initialValue = linkError && linkError.link;
  const errorMessage = linkError && getLinkErrorMessage(linkError.error);

  if (linkError && !isOpen) {
    setIsOpen(true);
  }

  const onValueSelect = (link: string) => {
    navigateToLink(link);
    onDialogRequestClose();
  };

  const onDialogRequestClose = () => {
    setIsOpen(false);
    resetLinkError();
  };

  return (
    <KeyboardShortcuts handlers={keyHandlers}>
      {isOpen && (
        <OpenConversationDialog
          initialValue={initialValue}
          hasError={Boolean(errorMessage)}
          errorMessage={errorMessage}
          onValueSelect={onValueSelect}
          onRequestClose={onDialogRequestClose}
        />
      )}
    </KeyboardShortcuts>
  );
};
